export default "__VITE_ASSET__Bg42rNWk__"